import { getStore } from '@dygc/shared'
import GlobalConfig from '@/global/config'
import { getDomain } from '@/assets/js/config/env'
import { routerObj } from '@/router/index.js'

function getAllUrl() {
  // 主模块功能的 通过全局注入的url跳转
  if (this.MainSurveyCompanyWalletUrl) {
    // 直接跳转 调研工厂钱包 企业钱包/我的钱包
    getMainUrl.call(this)
  } else {
    // 子模块(envelopeApproval) 支付 需要获取子模块中的 companyId和token
    getModuleUrl()
  }
}

//短信审批充值时 调用
function getModuleUrl() {
  let a = document.createElement('a')
  a.target = '_blank'
  const companyId = GlobalConfig.getCompanyId()
  const baseParams = '?companyid=' + companyId + '&token=' + GlobalConfig.getBaseToken()
  const surveyPersonalSmsUrl = getDomain() + '/user/wallet/textmessage' + baseParams
  const surveyCompanySmsUrl =  getDomain() + '/company/funds/textmessage' + baseParams
  if (companyId !== '0') {
    a.href = surveyCompanySmsUrl
  } else {
    a.href = surveyPersonalSmsUrl
  }
  a.click()
}
function getMainUrl(flag) {
  const baseParams = '?companyid=' + GlobalConfig.getCompanyId() + '&token=' + GlobalConfig.getBaseToken()
  const surveyPersonalWalletUrl =  getDomain() + '/user/wallet/list' + baseParams
  const surveyCompanyWalletUrl =  getDomain() + '/company/funds/list' + baseParams
  //短信管理url
  const surveyPersonalSmsUrl =  getDomain() + '/user/wallet/textmessage' + baseParams
  const surveyCompanySmsUrl =  getDomain() + '/company/funds/textmessage' + baseParams
  let a = document.createElement('a')
  a.target = '_blank'
  if (GlobalConfig.getCompanyId() - 0 !== 0) {
    a.href = flag == 'sms' ? surveyCompanySmsUrl : surveyCompanyWalletUrl
  } else {
    a.href = flag == 'sms' ? surveyPersonalSmsUrl : surveyPersonalWalletUrl
  }
  a.click()
}
function getMainUrlNew(flag) {
  const { href: surveyPersonalWalletUrl } = routerObj.resolve({path: "/user/wallet/wallet-list"});
  const { href: surveyCompanyWalletUrl } = routerObj.resolve({path:'/company/funds/funds-list'})

  //短信管理url
  const { href: surveyPersonalSmsUrl } = routerObj.resolve({path:'/user/wallet/text-message'})
  const { href: surveyCompanySmsUrl } = routerObj.resolve({path:'/company/funds/text-message'})
  let a = document.createElement('a')
  a.target = '_blank'
  if (GlobalConfig.getCompanyId() - 0 !== 0) {
    a.href = flag == 'sms' ? surveyCompanySmsUrl : surveyCompanyWalletUrl
  } else {
    a.href = flag == 'sms' ? surveyPersonalSmsUrl : surveyPersonalWalletUrl
  }
  a.click()
}
export { getModuleUrl, getMainUrl, getMainUrlNew, getAllUrl }
